import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import TableC from '../../basicElement/TableC';
import UpdatePITeam from './UpdatePITeam';
import { PITeamDetail as UpdateDetail } from './UpdateDetail';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

function getRender(text) {
    return text ? text === 'YES' ? '是' : '否' : '';
}

class PITeam extends Component {
    state = {
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { hospitalDepartmentId } = this.props;
        const { pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReviewPi,
            data: {
                offset: current,
                limit: pageSize,
                hospitalDepartmentId,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount = 0, datas = [] } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = record => {
        const { reviewPiId } = record;
        const options = {
            method: 'POST',
            url: API_URL.hospital.deleteReviewPi,
            data: { reviewPiId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { isAdd } = this.props;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: 'PI姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
        }, {
            title: '是否参与津石实际项目',
            dataIndex: 'whetherParticipateActualProjectShow',
            key: 'whetherParticipateActualProjectShow',
            width: 80,
        }, {
            title: '该PI所在团队的GCP意识',
            dataIndex: 'gcpAwarenessShow',
            key: 'gcpAwarenessShow',
            width: 100,
        }, {
            title: '该PI所在团队的配合度',
            dataIndex: 'cooperationDegreeShow',
            key: 'cooperationDegreeShow',
            width: 80,
        }, {
            title: '该PI所在团队的CFDA视察经验',
            dataIndex: 'cfdaInspectionExperienceShow',
            key: 'cfdaInspectionExperienceShow',
            width: 100,
        }, {
            title: '该PI所在团队是否接受津石CRC服务',
            dataIndex: 'acceptCrcServiceShow',
            key: 'acceptCrcServiceShow',
            width: 120,
        }, {
            title: '该PI所在团队有无专人负责临床试验',
            dataIndex: 'speciallyAssignedPersonShow',
            key: 'speciallyAssignedPersonShow',
            width: 120,
        }, {
            title: '津石合作紧密程度',
            dataIndex: 'closeCooperationShow',
            key: 'closeCooperationShow',
            width: 80,
        }, {
            title: '该PI所在团队推荐指数',
            dataIndex: 'recommendationIndexShow',
            key: 'recommendationIndexShow',
            width: 80,
        }, {
            title: 'PI/科室是否可以接受SSU进行PSV',
            dataIndex: 'whetherSsuPsv',
            key: 'whetherSsuPsv',
            width: 100,
            render: getRender
        }, {
            title: 'PI/科室是否可以接受SSU主导合同沟通',
            dataIndex: 'whetherSsuLead',
            key: 'whetherSsuLead',
            width: 100,
            render: getRender
        }, {
            title: 'PI是否愿意承接I期项目',
            dataIndex: 'whetherTakeProject',
            key: 'whetherTakeProject',
            width: 100,
            render: getRender
        }, {
            title: '该PI所在团队备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 160,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            width: isAdd ? 120 : 100,
            render: (text, record) => {
                const { typeName } = record;
                return (
                    <span>
                        {
                            isAdd &&
                            <span>
                                <a onClick={() => this.update(record)}>修改</a>
                                <span className="ant-divider" />
                                {
                                    typeName === 'CUSTOM' &&
                                    <span>
                                        <Popconfirm title='确定要删除吗?' onConfirm={() => this.delete(record)} okText="确定" cancelText="取消">
                                            <a>删除</a>
                                        </Popconfirm>
                                        <span className="ant-divider" />
                                    </span>
                                }
                            </span>
                        }
                        <a onClick={() => this.showDetail(record)}>更新日志</a>
                    </span>
                )
            }
        }];
        return columns;
    }


    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }
    
    handleTableChange = (params) => {
        this.setState({...params}, () => {
            this.loadData();
        });
    }

    update = record => {
        this.updateRef.show(record);
    }

    showDetail = record => {
        this.detailRef.show(record);
    }

    render() {
        const { isAdd, hospitalDepartmentId } = this.props;
        const { loading, pagination } = this.state;
        return (
            <div>
                {
                    isAdd &&
                    <div style={{ marginBottom: 12, textAlign: 'right' }}>
                        <Button type="primary" onClick={() => this.update()}>添加PI团队点评</Button>
                    </div>
                }
                <TableC
                    loading={loading}
                    rowKey="reviewPiId"
                    pagination={pagination}
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    className="PITeamTable"
                    onChange={this.handleTableChange}
                />
                <UpdateDetail ref={el => this.detailRef = el} loadData={this.loadData} />
                <UpdatePITeam ref={el => this.updateRef = el} loadData={this.loadData} hospitalDepartmentId={hospitalDepartmentId} />
            </div>
        )
    }
}

export default PITeam;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/PITeam.js